
    <table class="styled-table w-full ">
        <thead>
        <tr class="header">
            <th>PRODUIT</th>
            <th>QUANTITÉ</th>
            <th>REMISE</th>
            <th>PRIX D'ACHAT</th>
            <th>PRIX DE VENTE</th>
        </tr>
        </thead>
        <tbody>
        <tr style="height: 50px">
            <td>Blazer</td>
            <td>2</td>
            <td>0%</td>
            <td>50,000 TND</td>
            <td>150,000 TND</td>
        </tr>
        </tbody>
    </table>
